export default "__VITE_ASSET__BjLRIp9n__"